import { useState, useEffect } from 'react';
import apiClient from '../lib/api';

let cache = null;
let cacheTimestamp = 0;
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

/**
 * SWR-style hook for /api/public/company-info.
 * Caches in module scope for 5 min so multiple components don't hammer the endpoint.
 */
export function useCompanyInfo() {
  const [data, setData] = useState(cache);
  const [loading, setLoading] = useState(!cache);
  const [error, setError] = useState(null);

  useEffect(() => {
    const now = Date.now();
    if (cache && now - cacheTimestamp < CACHE_TTL) {
      setData(cache);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    apiClient
      .get('/public/company-info')
      .then((res) => {
        if (!cancelled) {
          cache = res.data;
          cacheTimestamp = Date.now();
          setData(res.data);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err);
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { data, loading, error };
}
